var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowRight = function SvgArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 10,
    fill: "currentColor",
    viewBox: "0 0 15 10"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.012 4.234 9.289 1.512l1.06-1.06L14.9 5l-4.55 4.549-1.06-1.06 2.754-2.755H0v-1.5z"
  })));
};
export { SvgArrowRight as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNSIgaGVpZ2h0PSIxMCIgdmlld0JveD0iMCAwIDE1IDEwIiBmaWxsPSJjdXJyZW50Q29sb3IiPgogIDxwYXRoIGQ9Ik0xMi4wMTE2IDQuMjM0MzhMOS4yODkwNiAxLjUxMTg0TDEwLjM0OTcgMC40NTExNzJMMTQuODk4NiA1LjAwMDAyTDEwLjM0OTcgOS41NDg4NEw5LjI4OTA2IDguNDg4MTdMMTIuMDQyOSA1LjczNDM4SDBWNC4yMzQzOEgxMi4wMTE2WiIgZmlsbD0iY3VycmVudENvbG9yIi8+Cjwvc3ZnPg==";